module.exports = __webpack_public_path__ + "assets/img/promotion.28384078.gif";